<template>
    <section class="export-generic-entities-index">
        <div class="col-md-12">
            <pim-header :header="myHeader"></pim-header>
            <div>
                <product-alerts :status="alert" v-model="alert"></product-alerts>
            </div>

            <transition name="vue-table-loader">
                <div class="vue-table-loader" v-if="isLoading"><span class="fa fa-cog fa-spin fa-3x"></span></div>
            </transition>

            <div class="card panel panel-default">
                <div class="card-block">
                    <form action="">
                        <input type="hidden" name="_token" :value="csrfToken">
                        <div class="row" v-if="isSingleVersion">
                            <div class="col-md-8">
                                <label for="" v-if="versionSelectField.label">
                                    <span class="label-title">{{versionSelectField.label}}</span>
                                    <span v-if="versionSelectField.required" class="required-field">*</span>
                                </label>
                                <input-selectbox v-model="versionSelectField.value" :field-data="versionSelectField"></input-selectbox>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-8">
                                <label for="" v-if="selectField.label">
                                    <span class="label-title">{{selectField.label}}</span>
                                    <span v-if="selectField.required" class="required-field">*</span>
                                </label>
                                <input-selectbox v-model="selectField.value" :field-data="selectField"></input-selectbox>
                            </div>
                        </div>
                        <div class="row">
                            <ul v-if="!attributesToExport.willExportAllAttribute">
                                <li v-for="att in attributesToExport.attributes" :key="`li-att-${att.id}`">
                                    "{{ att.name }}" - 
                                    <span
                                        style="text-decoration: underline;cursor: pointer;"
                                        v-on:click="removeAttributeFromExportList(att.id)"
                                    >
                                        remove
                                    </span>
                                </li>
                            </ul>
                            <ul v-if="attributesToExport.willExportAllAttribute">
                                <li>Will export all Attributes</li>
                            </ul>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <button v-on:click="addAttritubeToExportList()" type="button" class="btn btn-secondary">Add Attribute</button>
                            </div>
                            <div class="col-md-6">
                                <button v-on:click="switchAllAttributesToExport()" type="button" v-if="!attributesToExport.willExportAllAttribute" class="btn btn-secondary">Export All</button>

                                <button v-on:click="switchAllAttributesToExport()" type="button" v-if="attributesToExport.willExportAllAttribute" class="btn btn-secondary">Export Selected</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <button v-on:click="exportAttributes()" type="button" class="btn btn-primary" :disabled="exportButtonDisabled">Export</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host

    import Vue from 'vue';
    import VueEvents from 'vue-events';
    import axios from 'axios';

    import PimHeader from '../generic/pim-header';
    import InputSelectbox from '../form/form-selectbox.vue';
    import ProductAlerts from '../products/product-details-alerts.vue';

    Vue.use(VueEvents)

    export default {
        name: 'export-product-attribute-values-versions-index',
        props: ['csrfToken', 'exportType'],
        components: {
            'pim-header': PimHeader,
            'input-selectbox': InputSelectbox,
            'product-alerts': ProductAlerts,
        },
        data() {
            return {
                selectField: {
                    label: 'Select the Attributes to export',
                    required: true,
                    disabled: false,
                    type: 'select',
                    name: 'selectedEntity',
                    value: '',
                    options: dataObject.attributes
                },
                versionSelectField: {
                    label: 'Select the Version to export',
                    required: true,
                    disabled: false,
                    type: 'select',
                    name: 'selectedVersion',
                    value: '',
                    options: dataObject.versions
                },
                isLoading: false,
                alert: {
                    message: "",
                    status: "alert-success",
                    timeOut: 15000,
                },
                attributesToExport: {
                    willExportAllAttribute: false,
                    attributes: []
                },
                myHeader: '',
                isSingleVersion: false,
            }
        },
        computed: {
            exportButtonDisabled: function () {
                if (this.isSingleVersion) {
                    if (!this.versionSelectField.value) {
                        return true;
                    }
                }

                return (!this.attributesToExport.willExportAllAttribute && this.attributesToExport.attributes.length == 0);
            }
        },
        mounted() {
            this.isSingleVersion = this.exportType == 'single-version' ? true : false;
            this.myHeader = this.isSingleVersion ? 'Export Product Attribute Values' : 'Export Product Attribute Values Versions';
        },
        methods: {
            exportAttributes: function () {
                this.isLoading = true;

                let attributeIds = this.attributesToExport.attributes.map(att => att.id);

                let payload = {
                    'willExportAllAttribute': this.attributesToExport.willExportAllAttribute,
                    'attributeIds': attributeIds
                };
                if (this.isSingleVersion) {
                    payload.versionId = this.versionSelectField.value;
                }
                
                const exportUrl = this.isSingleVersion ? '/export-product-attribute-values' : '/export-product-attribute-values-versions'

                axios.post(base_url + exportUrl, payload)
                .then(function() {
                    this.alert.status = "alert-success";
                    this.alert.message = 'Success, export initiated, we are redirecting you to the Jobs page.';
                    setTimeout(function() {
                        window.location = "/jobs";
                    }, 2000);
                }.bind(this))
                .catch(function (error) {
                    this.alert.status = "alert-danger";
                    this.alert.message = error.response.data.message || 'There was an error, please try again later.';
                }.bind(this))
                .finally(function() {
                    this.isLoading = false;
                }.bind(this));
            },
            addAttritubeToExportList: function () {
                if (!this.selectField.value) {
                    this.alert.status = "alert-danger";
                    this.alert.message = 'Please, first select an Attribute';
                    return;
                }

                let selectedAttribute = this.selectField.options[this.selectField.value];

                if (selectedAttribute && !this.attributesToExport.attributes.some(att => att.id === selectedAttribute.id)) {
                    this.attributesToExport.attributes.push(this.selectField.options[this.selectField.value]);
                }
            },
            removeAttributeFromExportList: function (attributeId) {
                this.attributesToExport.attributes = this.attributesToExport.attributes.filter(att => att.id !== attributeId);
            },
            switchAllAttributesToExport: function () {
                this.attributesToExport.willExportAllAttribute = !this.attributesToExport.willExportAllAttribute;
            }
        }
    };
</script>
